import type { Control, FieldValue, FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { SimpleInputProps } from './SimpleInput'
import SimpleInput from './SimpleInput'

interface HFSimpleInputProps extends Omit<SimpleInputProps, 'min' | 'max'> {
  name: string
  control: Control<FieldValue<FieldValues>>
}

function HFSimpleInput({ name, control, required, ...rest }: HFSimpleInputProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div className='field'>
            <SimpleInput
              {...rest}
              value={field.value}
              onInput={e => field.onChange(e)}
              error={fieldState.invalid}
              required={required}
            />
            {required && fieldState.invalid && <p className='error-label'>{fieldState.error?.message}</p>}
          </div>
        )
      }}
    />
  )
}

export default HFSimpleInput
